import React, { useRef } from "react";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import { OverlayPanel } from "primereact/overlaypanel";
import { useNotifications } from "../../contexts/NotificationContext";
import NotificationDropdown from "./NotificationDropdown";

const NotificationBell = () => {
  const { unreadCount } = useNotifications();
  const opRef = useRef(null);

  const handleToggle = (e) => {
    if (opRef.current) opRef.current.toggle(e);
  };

  return (
    <>
      <Button
        icon="pi pi-bell"
        className="p-button-rounded p-button-text p-overlay-badge"
        aria-label="Notifications"
        tooltip="Notifications"
        tooltipOptions={{ position: "bottom" }}
        onClick={handleToggle}
      >
        {unreadCount > 0 && (
          <Badge
            value={unreadCount > 99 ? "99+" : unreadCount}
            severity="danger"
          />
        )}
      </Button>
      <OverlayPanel
        ref={opRef}
        showCloseIcon={false}
        dismissable
        style={{ width: "380px", maxWidth: "95vw" }}
      >
        <NotificationDropdown onClose={() => opRef.current?.hide()} />
      </OverlayPanel>
    </>
  );
};

export default NotificationBell;
